import { axiosInstance as axios } from "services";

export const updatePromotionalCode = async (id, body) => {
  try {
    const { data } = await axios.put(`/admin/subscription/promotional-codes/${id}`, body);
    if (!data.success) throw new Error(data.error?.message || "Failed to update promotional code");
    return data;
  } catch (error) {
    if (error.response?.data?.error?.message) {
      throw new Error(error.response.data.error.message);
    }
    throw error;
  }
};

